module.exports = __webpack_public_path__ + "img/privacy.f155ec14.svg";